<template element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { usercenterinfo, requestIdtrans } from '@/api/home'
export default {
  data() {
    return {}
  },
  watch: {},
  methods: {
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      const path = this.$route.path
      if (res && res.code == 0) {
        if (path == '/') {
          this.$router.push('/bench')
        } else {
          this.$router.push(path)
          if (this.$route.query.requestid) {
            location.reload()
          }
        }
      }
    },
    requestIdtrans() {
      let that = this
      let params = {
        clientType: 'web',
        requestId: this.$route.query.requestid,
      }
      // return false
      that.loading = true
      requestIdtrans(params)
        .then((res) => {
          localStorage.setItem('token', res.data.data.token)
          localStorage.setItem('roleTypes', res.data.data.roleType)
          that.usercenterinfo()
          that.loading = false
        })
        .catch(() => {
          that.loading = false
        })
    },
  },
  components: {
    // 声明子组件名字
  },
  created() {
    if (this.$route.query.requestid) {
      this.requestIdtrans()
    } else {
      let pathToken = this.$route.query.token
      if (pathToken) {
        localStorage.clear()
        localStorage.setItem('token', pathToken)
        this.usercenterinfo()
        return false
      }
      if (this.$route.path == '/qywx/index') {
      } else {
        this.usercenterinfo()
      }
    }
  },
  computed: {},
  mounted() {
    //			window.addEventListener( 'beforeunload', e => this.set() );
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/App.vue